import { HTMLAttributes } from 'react'

export const DEFAULT_COLOR = '#E1E4EA'

export type ColorTokenProps = HTMLAttributes<HTMLSpanElement> & {
  color?: string
  className?: string
}
